import AWS from 'aws-sdk/global'
import defaultValues from './defaultValues.js'

export default class GeneralLogin {
  static setAWSCredentials (idProvider, token, unauth = false) {
    var logins = {}
    var userPoolId = unauth ? window.CONFIG.UnauthUserPoolId : window.CONFIG.UserPoolId
    var identityPoolId = unauth ? window.CONFIG.UnauthIdentityPoolId : window.CONFIG.IdentityPoolId

    if (idProvider === 'cognito') {
      var cognitoIDP = 'cognito-idp.'.concat(window.CONFIG.Region, '.amazonaws.com/', userPoolId)
      logins[cognitoIDP] = token
    } else if (idProvider === 'google') {
      logins['accounts.google.com'] = token
    } else if (idProvider === 'facebook') {
      logins['graph.facebook.com'] = token
    }

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: identityPoolId,
      Logins: logins
    })
  }

  static refreshAWSCredentials () {
    return new Promise((resolve, reject) => {
      AWS.config.credentials.refresh((error) => {
        (error) ? reject(error) : resolve(AWS.config.credentials)
      })
    })
  }

  static setFromResult (commit, result) {
    commit('updateCognitoId', result.identityId)
    commit('updateAccessKeyId', result.accessKeyId)
    commit('updateSecretAccessKey', result.secretAccessKey)
    commit('updateSessionToken', result.sessionToken)
    commit('updateExpireTime', result.expireTime)
  }

  static setToNull (commit) {
    commit('updateIdProvider', defaultValues.idProvider)
    commit('updateAccessKeyId', defaultValues.accessKeyId)
    commit('updateSecretAccessKey', defaultValues.secretAccessKey)
    commit('updateSessionToken', defaultValues.sessionToken)
    commit('updateExpireTime', defaultValues.expireTime)
    commit('products/updateProduct', defaultValues.product)
    commit('products/clearZips')
    commit('products/updatePlanBillingPeriodEndDate', defaultValues.planBillingPeriodEndDate)
    commit('products/updatePlanBillingPeriodStartDate', defaultValues.planBillingPeriodStartDate)
    commit('products/updatePlanNextBillingDate', defaultValues.planNextBillingDate)
    commit('products/updatePriorityPlanStatus', defaultValues.priorityPlanStatus)
    commit('products/updateCurrentPlanName', defaultValues.currentPlanName)
    commit('products/updateCurrentPlanPrice', defaultValues.currentPlanPrice)
    commit('products/updateCurrentPlanZipCodes', defaultValues.currentPlanZipCodes)
    commit('products/updateCouponBudget', defaultValues.couponBudget)
    commit('products/updateCouponBudgetedClicks', defaultValues.couponBudgetedClicks)
    commit('products/updateCouponCategory', defaultValues.couponCategory)
    commit('products/updateCouponCombosAllowed', defaultValues.couponCombosAllowed)
    commit('products/updateCouponExpiration', defaultValues.couponExpiration)
    commit('products/updateCouponId', defaultValues.couponId)
    commit('products/updateCouponCustomerReuses', defaultValues.couponCustomerReuses)
    commit('products/updateCouponDefaultResponse', defaultValues.couponDefaultResponse)
    commit('products/updateCouponDetails', defaultValues.couponDetails)
    commit('products/updateCouponDiscountedPrice', defaultValues.couponDiscountedPrice)
    commit('products/updateCouponFreeClicks', defaultValues.couponFreeClicks)
    commit('products/updateCouponListPrice', defaultValues.couponListPrice)
    commit('products/updateCouponName', defaultValues.couponName)
    commit('products/updateCouponPromotionalCode', defaultValues.couponPromotionalCode)
    commit('products/updateCouponStatus', defaultValues.couponStatus)
    commit('updateCognitoId', defaultValues.cognitoId)
    commit('business/updateEmail', defaultValues.email)
    commit('business/updatePhoneNumber', defaultValues.phoneNumber)
    commit('business/updateMFA', defaultValues.MFA)
    commit('business/updateBusinessName', defaultValues.businessName)
    commit('business/updateAddress', defaultValues.address)
    commit('business/updateAddressTwo', defaultValues.addressTwo)
    commit('business/updateCity', defaultValues.city)
    commit('business/updateState', defaultValues.state)
    commit('business/updateZip', defaultValues.zip)
    commit('business/updateBusinessPhone', defaultValues.businessPhone)
    commit('business/updateWebsite', defaultValues.website)
    commit('business/updateCompanyInfo', defaultValues.companyInfo)
    commit('business/updateAreasServiced', JSON.parse(JSON.stringify(defaultValues.areasServiced)))
    commit('business/updateAlteredForms', JSON.parse(JSON.stringify(defaultValues.alteredForms)))
    commit('business/updateAdminEmail', defaultValues.adminEmail)
    commit('business/updateAdminFirstName', defaultValues.adminFirstName)
    commit('business/updateAdminLastName', defaultValues.adminLastName)
    commit('business/updateAdminPhone', defaultValues.adminPhone)
    commit('business/updateCsEmail', defaultValues.csEmail)
    commit('business/updateCsFirstName', defaultValues.csFirstName)
    commit('business/updateCsLastName', defaultValues.csLastName)
    commit('business/updateCsPhone', defaultValues.csPhone)
    commit('business/updateQcEmail', defaultValues.qcEmail)
    commit('business/updateQcFirstName', defaultValues.qcFirstName)
    commit('business/updateQcLastName', defaultValues.qcLastName)
    commit('business/updateQcPhone', defaultValues.qcPhone)
    commit('business/updateSalesEmail', defaultValues.salesEmail)
    commit('business/updateDisplayName', defaultValues.displayName)
    commit('business/updateSalesPhoneNumber', defaultValues.salesPhoneNumber)
    commit('business/updateInsuranceAmount', defaultValues.insuranceAmount)
    commit('business/updateLicenseNumber', defaultValues.licenseNumber)
    commit('business/updateCostLevel', defaultValues.costLevel)
    commit('business/updateAvailabilityLevel', defaultValues.availabilityLevel)
    commit('business/updateTimes', JSON.parse(JSON.stringify(defaultValues.times)))
    commit('business/updateEmergencies', defaultValues.emergencies)
    commit('business/updateSelectedServices', JSON.parse(JSON.stringify(defaultValues.selectedServices)))
    commit('business/updateImages', JSON.parse(JSON.stringify(defaultValues.images)))
    commit('business/updateProfileImage', defaultValues.profileImage)
    commit('user/updateUserType', defaultValues.userType)
    commit('business/updateBannerImage', defaultValues.bannerImage)
    commit('business/updateCompanyInfoTwo', defaultValues.companyInfoTwo)
    commit('business/updateLanguagesSpoken', defaultValues.languagesSpoken)
    commit('business/updateSSN', defaultValues.ssn)
    commit('business/updateYearEstablished', defaultValues.yearEstablished)
    commit('business/updateServiceType', JSON.parse(JSON.stringify(defaultValues.serviceType)))
    commit('business/updateHideAddress', defaultValues.hideAddress)
    commit('business/updateAllowSendTexts', defaultValues.allowSendTexts)
    commit('business/updateEnableQuoteRequest', defaultValues.enableQuoteRequest)
    commit('business/updateHideYears', defaultValues.hideYears)
    commit('business/updateBusinessId', defaultValues.businessId)
    commit('business/updateCouponPaymentOverdue', defaultValues.coponPaymentOverdue)
    commit('business/updatePaymentFailureNotification', defaultValues.paymentFailureNotification)
    commit('user/updateLegalFirstName', defaultValues.userLegalFirstName)
    commit('user/updateLastName', defaultValues.userLastName)
    commit('user/updateEmail', defaultValues.userEmail)
    commit('user/updateCellPhone', defaultValues.userCellPhone)
    commit('user/updateStreet1', defaultValues.userStreet1)
    commit('user/updateStreet2', defaultValues.userStreet2)
    commit('user/updateCity', defaultValues.userCity)
    commit('user/updateState', defaultValues.userState)
    commit('user/updateZipCode', defaultValues.userZipCode)
    commit('user/updateCouponAlerts', JSON.parse(JSON.stringify(defaultValues.userCouponAlerts)))
    commit('user/updatePromotionAlerts', JSON.parse(JSON.stringify(defaultValues.userPromotionAlerts)))
    commit('user/updateImages', JSON.parse(JSON.stringify(defaultValues.userImages)))
    commit('user/updateProfileImage', defaultValues.userProfileImage)
    commit('user/updateSavedBusinesses', JSON.parse(JSON.stringify(defaultValues.userSavedBusinesses)))
    commit('user/updateSavedHouses', JSON.parse(JSON.stringify(defaultValues.userSavedHouses)))
    commit('user/updateMyLenderCode', defaultValues.userMyLenderCode)
    commit('user/updateMyRealtorCode', defaultValues.userMyRealtorCode)
    commit('user/updateMyServiceProviderId', defaultValues.userMyServiceProviderId)
    commit('user/updateBlockList', JSON.parse(JSON.stringify(defaultValues.blockList)))
    commit('user/updateNotificationNumber', defaultValues.notificationNumber)
    commit('lender/updateBranchLink', defaultValues.lenderBranchLink)
    commit('lender/updateBranchQRCode', defaultValues.lenderBranchQRCode)
    commit('lender/updateBrokerageName', defaultValues.lenderBrokerageName)
    commit('lender/updateBrokeragePicture', defaultValues.lenderBrokeragePicture)
    commit('lender/updateLicenseNumber', defaultValues.lenderLicenseNumber)
    commit('lender/updatePhoneNumber', defaultValues.lenderPhoneNumber)
    commit('lender/updateProfilePicture', defaultValues.lenderProfilePicture)
    commit('lender/updateLenderCode', defaultValues.lenderCode)
    commit('lender/updateLenderCognitoId', defaultValues.lenderCognitoId)
    commit('lender/updateLenderBackgroundColor', defaultValues.lenderBackgroundColor)
    commit('lender/updateLenderEmail', defaultValues.lenderEmail)
    commit('lender/updateLenderName', defaultValues.lenderName)
    commit('lender/updateLenderPaymentHistory', JSON.parse(JSON.stringify(defaultValues.lenderPaymentHistory)))
    commit('lender/updateLenderTextColor', defaultValues.lenderTextColor)
    commit('lender/updateSubscriptionId', defaultValues.lenderSubscriptionId)
    commit('lender/updateSubscriptionPrice', defaultValues.lenderSubscriptionPrice)
    commit('lender/updateSubscriptionDiscountAmount', defaultValues.lenderSubscriptionDiscountAmount)
    commit('lender/updateSubscriptionDiscountExpirationDate', defaultValues.lenderSubscriptionDiscountExpirationDate)
    commit('lender/updateSubscriptionStartDate', defaultValues.lenderSubscriptionStartDate)
    commit('lender/updateSubscriptionEndDate', defaultValues.lenderSubscriptionEndDate)
    commit('lender/updateSubscriptionNextBillingDate', defaultValues.lenderSubscriptionNextBillingDate)
    commit('lender/updateSubscriptionRenewal', defaultValues.lenderSubscriptionRenewal)
    commit('lender/updateSubscriptionCreditCardType', defaultValues.lenderSubscriptionCreditCardType)
    commit('lender/updateSubscriptionCreditCardLastFour', defaultValues.lenderSubscriptionCreditCardLastFour)
    commit('lender/updateSubscriptionCustomFlag', defaultValues.lenderSubscriptionCustomFlag)
    commit('lender/updateClientIds', JSON.parse(JSON.stringify(defaultValues.lenderClientIds)))
    commit('lender/updateBraintreeCustomerId', defaultValues.lenderBraintreeCustomerId)
    commit('lender/updatePremium', defaultValues.lenderPremium)
    commit('realtor/updateBranchLink', defaultValues.realtorBranchLink)
    commit('realtor/updateBranchQRCode', defaultValues.realtorBranchQRCode)
    commit('realtor/updateBrokerageName', defaultValues.realtorBrokerageName)
    commit('realtor/updateBrokeragePicture', defaultValues.realtorBrokeragePicture)
    commit('realtor/updateLicenseNumber', defaultValues.realtorLicenseNumber)
    commit('realtor/updatePhoneNumber', defaultValues.realtorPhoneNumber)
    commit('realtor/updateProfilePicture', defaultValues.realtorProfilePicture)
    commit('realtor/updateRealtorCode', defaultValues.realtorCode)
    commit('realtor/updateRealtorCognitoId', defaultValues.realtorCognitoId)
    commit('realtor/updateRealtorBackgroundColor', defaultValues.realtorBackgroundColor)
    commit('realtor/updateRealtorEmail', defaultValues.realtorEmail)
    commit('realtor/updateRealtorName', defaultValues.realtorName)
    commit('realtor/updateRealtorPaymentHistory', JSON.parse(JSON.stringify(defaultValues.realtorPaymentHistory)))
    commit('realtor/updateRealtorTextColor', defaultValues.realtorTextColor)
    commit('realtor/updateSubscriptionId', defaultValues.realtorSubscriptionId)
    commit('realtor/updateSubscriptionPrice', defaultValues.realtorSubscriptionPrice)
    commit('realtor/updateSubscriptionDiscountAmount', defaultValues.realtorSubscriptionDiscountAmount)
    commit('realtor/updateSubscriptionDiscountExpirationDate', defaultValues.realtorSubscriptionDiscountExpirationDate)
    commit('realtor/updateSubscriptionStartDate', defaultValues.realtorSubscriptionStartDate)
    commit('realtor/updateSubscriptionEndDate', defaultValues.realtorSubscriptionEndDate)
    commit('realtor/updateSubscriptionNextBillingDate', defaultValues.realtorSubscriptionNextBillingDate)
    commit('realtor/updateSubscriptionRenewal', defaultValues.realtorSubscriptionRenewal)
    commit('realtor/updateSubscriptionCreditCardType', defaultValues.realtorSubscriptionCreditCardType)
    commit('realtor/updateSubscriptionCreditCardLastFour', defaultValues.realtorSubscriptionCreditCardLastFour)
    commit('realtor/updateSubscriptionCustomFlag', defaultValues.realtorSubscriptionCustomFlag)
    commit('realtor/updateClientIds', JSON.parse(JSON.stringify(defaultValues.realtorClientIds)))
    commit('realtor/updateBraintreeCustomerId', defaultValues.realtorBraintreeCustomerId)
    commit('realtor/updatePremium', defaultValues.realtorPremium)
    commit('serviceProvider/updateAddress', defaultValues.serviceProviderCompanyAddress)
    commit('serviceProvider/updateBranchLink', defaultValues.serviceProviderCompanyBranchLink)
    commit('serviceProvider/updateBranchQRCode', defaultValues.serviceProviderCompanyBranchQRCode)
    commit('serviceProvider/updateCallNumber', defaultValues.serviceProviderCompanyCallPhoneNumber)
    commit('serviceProvider/updateCategory', defaultValues.serviceProviderCompanyCategory)
    commit('serviceProvider/updateCouponText', defaultValues.serviceProviderCompanyCouponText)
    commit('serviceProvider/updateDetails', defaultValues.serviceProviderCompanyDetails)
    commit('serviceProvider/updateEmail', defaultValues.serviceProviderCompanyEmail)
    commit('serviceProvider/updateCompanyId', defaultValues.serviceProviderCompanyId)
    commit('serviceProvider/updateLatitude', defaultValues.serviceProviderCompanyLatitude)
    commit('serviceProvider/updateLogo', defaultValues.serviceProviderCompanyLogo)
    commit('serviceProvider/updateLongitude', defaultValues.serviceProviderCompanyLongitude)
    commit('serviceProvider/updateCompanyName', defaultValues.serviceProviderCompanyName)
    commit('serviceProvider/updateOwnerId', defaultValues.serviceProviderCompanyOwnerId)
    commit('serviceProvider/updatePaymentHistory', defaultValues.serviceProviderCompanyPaymentHistory)
    commit('serviceProvider/updatePreferredCommunication', defaultValues.serviceProviderCompanyPreferredCommunication)
    commit('serviceProvider/updatePremium', defaultValues.serviceProviderCompanyPremium)
    commit('serviceProvider/updateReferralText', defaultValues.serviceProviderCompanyReferralText)
    commit('serviceProvider/updateSearchRadius', defaultValues.serviceProviderCompanySearchRadius)
    commit('serviceProvider/updateSubscriptionId', defaultValues.serviceProviderCompanySubscriptionId)
    commit('serviceProvider/updateSubscriptionPrice', defaultValues.serviceProviderCompanySubscriptionPrice)
    commit('serviceProvider/updateSubscriptionDiscountAmount', defaultValues.serviceProviderCompanySubscriptionDiscountAmount)
    commit('serviceProvider/updateSubscriptionDiscountExpirationDate', defaultValues.serviceProviderCompanySubscriptionDiscountExpirationDate)
    commit('serviceProvider/updateSubscriptionStartDate', defaultValues.serviceProviderCompanySubscriptionStartDate)
    commit('serviceProvider/updateSubscriptionEndDate', defaultValues.serviceProviderCompanySubscriptionEndDate)
    commit('serviceProvider/updateSubscriptionNextBillingDate', defaultValues.serviceProviderCompanySubscriptionNextBillingDate)
    commit('serviceProvider/updateSubscriptionRenewal', defaultValues.serviceProviderCompanySubscriptionRenewal)
    commit('serviceProvider/updateSubscriptionCreditCardType', defaultValues.serviceProviderCompanySubscriptionCreditCardType)
    commit('serviceProvider/updateSubscriptionCreditCardLastFour', defaultValues.serviceProviderCompanySubscriptionCreditCardLastFour)
    commit('serviceProvider/updateSubscriptionCustomFlag', defaultValues.serviceProviderCompanySubscriptionCustomFlag)
    commit('serviceProvider/updateTextNumber', defaultValues.serviceProviderCompanyTextPhoneNumber)
    commit('business/updateBlockList', JSON.parse(JSON.stringify(defaultValues.blockList)))
    commit('business/updateServiceAreaCoords', JSON.parse(JSON.stringify(defaultValues.serviceAreaCoords)))
    commit('business/updateSpecialties', JSON.parse(JSON.stringify(defaultValues.specialties)))
    commit('business/updateHasAdvertisingPlan', defaultValues.hasAdvertisingPlan)
    commit('property/clearData')
  }

  static clearCredentials (commit) {
    this.setToNull(commit)
    AWS.config.credentials = null
    localStorage.clear()
  }
}



// WEBPACK FOOTER //
// ./src/store/lib/generalLogin.js